export default __webpack_public_path__ + "static/media/ivote.89cad450.png";